"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 系统参数配置模块
var _default = exports.default = {
  getSysConfigList: function getSysConfigList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/sysconfig/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getSysConfigDetail: function getSysConfigDetail(id) {
    return (0, _request.default)({
      url: '/protected/sysconfig/query/' + id,
      method: 'get'
    });
  },
  saveSysConfig: function saveSysConfig(data) {
    return (0, _request.default)({
      url: '/protected/sysconfig/save',
      method: 'post',
      data: data
    });
  },
  deleteSysConfig: function deleteSysConfig(data) {
    return (0, _request.default)({
      url: '/protected/sysconfig/delete',
      method: 'post',
      data: data
    });
  }
};